import { PipesModule } from "src/app/_pipes/pipes.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { HomePageRoutingModule } from "./home-routing.module";

import { HomePage } from "./home.page";
import { TranslateModule } from "@ngx-translate/core";
import { SharedDirectivesModule } from "../../_directives/shared-directives.module";
import { PaginationClientSideModule } from "../_component/pagination-client-side/pagination-client-side.module";
import { LoadingComponent } from "../_component/loading/loading.component";
import { LoadingModule } from "../_component/loading/loading.module";
import { CommunityTileComponent } from "./community-tile/community-tile.component";
import { InfoTileComponent } from "./info-tile/info-tile.component";
import { HeaderModule } from "../../_component/header/header.module";
import { UserSettingsComponentModule } from "../_component/user-settings/user-settings.module";
import { InvitationViewModule } from "../invitation/invitation-view/invitation-view.module";
import { ProductTileModule } from "../market/product-tile/product-tile.module";
import { SwiperModule } from "swiper/angular";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        HomePageRoutingModule,
        TranslateModule,
        SharedDirectivesModule,
        PaginationClientSideModule,
        InvitationViewModule,
        LoadingModule,
        HeaderModule,
        UserSettingsComponentModule,
        ProductTileModule,
        PipesModule,
        SwiperModule,
    ],
    declarations: [HomePage, CommunityTileComponent, InfoTileComponent]
})
export class HomePageModule {}
